import sk from 'date-fns/locale/sk';

const DateTimeFormats = {
  sunday: 'Ne',
  monday: 'Po',
  tuesday: 'Ut',
  wednesday: 'St',
  thursday: 'Št',
  friday: 'Pi',
  saturday: 'So',
  ok: 'OK',
  today: 'Dnes',
  yesterday: 'Včera',
  now: 'Teraz',
  hours: 'Hodiny',
  minutes: 'Minúty',
  seconds: 'Sekundy',
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  shortDateFormat: 'dd.MM.yyyy',
  shortTimeFormat: 'HH:mm',
  dateLocale: sk as any,
};

const Combobox = {
  noResultsText: 'Žiadne výsledky',
  placeholder: 'Vybrať',
  searchPlaceholder: 'Hľadať',
  checkAll: 'Všetky',
};

const CreatableComboBox = {
  ...Combobox,
  newItem: 'Nová položka',
  createOption: 'Vytvoriť možnosť "{0}"',
};

export default {
  code: 'sk-SK',
  common: {
    loading: 'Načítava sa...',
    emptyMessage: 'Žiadne dáta',
    remove: 'Odstrániť',
    clear: 'Vyčistiť',
  },
  Plaintext: {
    unfilled: 'Nevyplnené',
    notSelected: 'Nevybrané',
    notUploaded: 'Nenahrané',
  },
  Pagination: {
    more: 'Viac',
    prev: 'Predchádzajúca',
    next: 'Ďalšia',
    first: 'Prvá',
    last: 'Posledná',
    limit: '{0} / strana',
    total: 'Celkový počet riadkov: {0}',
    skip: 'Prejsť na {0}',
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: 'Posledných 7 dní',
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: 'Inicializovaný',
    progress: 'Nahrávanie',
    error: 'Chyba',
    complete: 'Dokončené',
    emptyFile: 'Prázdny',
    upload: 'Nahrať',
    removeFile: 'Odstrániť súbor',
  },
  CloseButton: {
    closeLabel: 'Zavrieť',
  },
  Breadcrumb: {
    expandText: 'Zobraziť cestu',
  },
  Toggle: {
    on: 'Otvoriť',
    off: 'Zavrieť',
  },
};
